import React, { useEffect } from 'react'

import { usePfCatalogue } from 'dataQueries/purchaseFlowRevamp.query'
import { logger } from 'utils/logging'
import { clampDiscountPercentage } from '../store/workspaceDiscount'
import { WorkspaceDiscountContext } from './workspaceDiscountContext'

/** Puts the open session's workspace discount, from the catalogue it was priced with, in reach of every price. */
export const WorkspaceDiscountProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const raw = usePfCatalogue().data?.discountPercentage
  const discount = clampDiscountPercentage(raw)

  // The clamp keeps prices sane; a value outside 0-100 is still bad data from the catalogue and is reported.
  useEffect(() => {
    if (raw === null || raw === undefined || raw === discount) return
    logger.warn('PF revamp: catalogue discount outside 0-100, clamped', undefined, {
      context: { component: 'WorkspaceDiscountProvider', action: 'clamp_discount', metadata: { raw, clamped: discount } },
    })
  }, [raw, discount])

  return <WorkspaceDiscountContext.Provider value={discount}>{children}</WorkspaceDiscountContext.Provider>
}
